import type { Color, Role } from '@domain/chess/types';

const ROLE_LETTER: Record<Role, string> = {
  k: 'K',
  q: 'Q',
  r: 'R',
  b: 'B',
  n: 'N',
  p: 'P',
};

/** Maestro set (Lichess). */
export function pieceUrl(color: Color, role: Role): string {
  const side = color === 'w' ? 'w' : 'b';
  return `/pieces/maestro/${side}${ROLE_LETTER[role]}.svg`;
}
